import { Component, h, Prop, Element, Watch, State } from '@stencil/core';
import { JackeryDropdown as _JackeryDropdown } from '../jackery-dropdown/jackery-dropdown';
import { star } from '../../utils/utils';

@Component({
  tag: 'jackery-commetn-header',
  styleUrl: 'jackery-commetn-header.css',
  shadow: true,
})
export class JackeryCommetnHeader {
  @Element() element: HTMLElement;
  @Prop() rating: string;
  @Prop() count: string;
  @Prop() list: string;
  @State() reviews: {rating: string, num: number, percent: number}[] = [
    { rating: "5", num: 0, percent: 0},
    { rating: "4", num: 0, percent: 0},
    { rating: "3", num: 0, percent: 0},
    { rating: "2", num: 0, percent: 0},
    { rating: "1", num: 0, percent: 0},
  ]
  @Watch('list')
  listChanged(newValue: string, _oldValue: string) {
    try {
      this.reviews = JSON.parse(newValue)
    } catch (error) {
      console.log(error)
    }
  }

  private handleScrollToComment() {
    const target = document.querySelector('jackery-comment')
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  render() {
    return (
      <div>
        <jackery-dropdown is-right hover-able>
            <div onClick={this.handleScrollToComment} id="jackery-comment-header_wrapper" class="sort-box flex items-center" slot="trigger">
              <div class="flex">
                <jackery-rating score={parseInt(this.rating) || 0} />
                <span>{this.rating}({this.count} reviews)</span>
              </div>
            </div>

            <div class={`comment_header_rating_item review_rate_section flex flex-col`}>
                {/* 无法响应list map */}
                <div class="areviews_rating_filter flex items-center" data-rating={5}>
                  <div class="flex items-center">
                    5
                    <div class="icon-star" innerHTML={star()}></div>
                  </div>

                  <div 
                    class="progress_bar_con"
                    style={{
                      '--percent': this.reviews[0].percent.toString()
                    }}
                  >
                    <div class="progress_bar_inner"></div>
                  </div>

                  <div class="total_reviews_number_Rating">
                    <span>{this.reviews[0].num}</span>
                  </div>
                </div>

                <div class="areviews_rating_filter flex items-center" data-rating={4}>
                  <div class="flex items-center">
                    4
                    <div class="icon-star" innerHTML={star()}></div>
                  </div>

                  <div 
                    class="progress_bar_con"
                    style={{
                      '--percent': this.reviews[1].percent.toString()
                    }}
                  >
                    <div class="progress_bar_inner"></div>
                  </div>

                  <div class="total_reviews_number_Rating">
                    <span>{this.reviews[1].num}</span>
                  </div>
                </div>

                <div class="areviews_rating_filter flex items-center" data-rating={3}>
                  <div class="flex items-center">
                    3
                    <div class="icon-star" innerHTML={star()}></div>
                  </div>

                  <div 
                    class="progress_bar_con"
                    style={{
                      '--percent': this.reviews[2].percent.toString()
                    }}
                  >
                    <div class="progress_bar_inner"></div>
                  </div>

                  <div class="total_reviews_number_Rating">
                    <span>{this.reviews[2].num}</span>
                  </div>
                </div>

                <div class="areviews_rating_filter flex items-center" data-rating={2}>
                  <div class="flex items-center">
                    2
                    <div class="icon-star" innerHTML={star()}></div>
                  </div>

                  <div 
                    class="progress_bar_con"
                    style={{
                      '--percent': this.reviews[3].percent.toString()
                    }}
                  >
                    <div class="progress_bar_inner"></div>
                  </div>

                  <div class="total_reviews_number_Rating">
                    <span>{this.reviews[3].num}</span>
                  </div>
                </div>

                <div class="areviews_rating_filter flex items-center" data-rating={1}>
                  <div class="flex items-center">
                    1
                    <div class="icon-star" innerHTML={star()}></div>
                  </div>

                  <div 
                    class="progress_bar_con"
                    style={{
                      '--percent': this.reviews[4].percent.toString()
                    }}
                  >
                    <div class="progress_bar_inner"></div>
                  </div>

                  <div class="total_reviews_number_Rating">
                    <span>{this.reviews[4].num}</span>
                  </div>
                </div>
              </div>
          </jackery-dropdown>
      </div>
    );
  }
}
